// extracted by mini-css-extract-plugin
module.exports = {"container":"DragFile_container__XztEw","container__description":"DragFile_container__description__2VYFj"};